<form [formGroup]="form">
  <div class="control">
    <label>Navn</label>
    <input pInputText formControlName="navn" />
  </div>
  <div class="control">
    <label>Registreringsnummer</label>
    <input pInputText formControlName="regnr" />
  </div>
  <div class="flex gap-2">
    <p-button
      label="Søg"
      (click)="onClickSearch()"
      [loading]="puService.datasource.isLoading()"
      icon="pi pi-search"
      type="submit"
    />
    <p-button
      label="Nulstil"
      (click)="onClickReset()"
      icon="pi pi-times"
      severity="secondary"
      outlined
    />
  </div>
</form>

@if (noHits()) {
<p-message text="Ingen hits" severity="error" styleClass="mt-4" />
}
